// I1b partial case: the Actual axis was explicitly requested (Model filter/group-by) but a
// dim filter dropped every Actual row. Pure presentational; the string lives in chartChrome.
// Mirrors DimNotApplicableNote's shape exactly.
import { Alert } from '@mui/material'
import { actualAxisDropNote } from '~/components/Charts/chrome/chartChrome'

export function ActualAxisNote({ dims }: { dims: string[] }) {
  return (
    <Alert severity="warning" sx={{ py: 0 }}>
      {actualAxisDropNote(dims)}
    </Alert>
  )
}
